// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'ant-design-vue/dist/antd.css';
import router from './router'
import i18n from "./i18n/index";
import Antd from 'ant-design-vue';
import store from './store';
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";
Vue.use(VueEasytable);
Vue.use(Antd);
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n, //注意：一定要加进去
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js